export default "__VITE_ASSET__BW6_7Fkp__"